module.exports = __webpack_public_path__ + "static/media/24UHCHR13.a3119e9d.jpg";